var React = require('react');

function MenuDots (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.201.661a.875.875 0 01.486-.147V.45v.063a.876.876 0 11-.17 1.733A.875.875 0 011.2.661zm5.313 0A.875.875 0 017 .514V.45v.063a.876.876 0 11-.17 1.733.875.875 0 01-.316-1.586zm6.285 1.455a.875.875 0 11-.972-1.454.875.875 0 01.972 1.454zM1.2 11.286a.875.875 0 11.973 1.456.875.875 0 01-.973-1.456zm5.313 0a.875.875 0 11.972 1.456.875.875 0 01-.972-1.456zm5.312 0a.875.875 0 11.973 1.456.875.875 0 01-.973-1.456zM1.201 5.974a.875.875 0 11.973 1.455.875.875 0 01-.973-1.455zm5.313 0a.875.875 0 11.972 1.455.875.875 0 01-.972-1.455zm5.312 0a.875.875 0 11.973 1.454.875.875 0 01-.973-1.454z","fill":"#4AA483","stroke":"#4AA483","strokeWidth":".125"}));
}

MenuDots.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = MenuDots;

MenuDots.default = MenuDots;
